import './modules/devicesHandler.js';
import { padLeft } from './modules/common.js';
import { More, linkBtn, functionBtn, pagination } from './modules/components.js';

import { topMenu } from './modules/topMenu.js';
import { initScrollReveal } from './modules/scrollReveal.js';
import { initFadeTextAnimation } from './modules/text-fade.js';

// 測試
import { initHighlight } from './modules/linkHighlight.js';

import './index.js';


document.addEventListener('DOMContentLoaded', () => {
	topMenu();

	initHighlight([
		'nav ul.menu a',
		'footer .footer-top ul a'
	])

	$('#preload').delay(500).fadeOut(500, function() {
		// 等loading結束在套用效果
	});

	initScrollReveal();
	initFadeTextAnimation();
});


// 批量掛載到 window
const globals = {
	padLeft,
	More,
	linkBtn,
	functionBtn,
	pagination,
};

Object.assign(window, globals);